/*
@GetMapping("/{tireSize}/ymm/{year}/{make}/{model}/BAC/{bac}/brand/{brand}")
public String getYMMTireSizeSummaryWithBrand(@PathVariable("year") String year,
@PathVariable("make") String make, @PathVariable("model") String model,
@PathVariable("tireSize") String tireSize, @PathVariable("bac") String bac,
@PathVariable("brand") String brand) {
    logger.info("**********getYMMTireSizeSummaryWithBrand**********");
    TireInfoDetails tireInfoDetails = TireInfoDetails.parseTireSize(tireSize);
    return tireInfoService.getTireInfoBySize(year, make, model, tireInfoDetails, bac, brand);
}

@GetMapping("/{tireSize}/ymm/{year}/{make}/{model}/BAC/{bac}")
public String getYMMTireSizeSummary(@PathVariable("year") String year,
@PathVariable("make") String make, @PathVariable("model") String model,
@PathVariable("tireSize") String tireSize, @PathVariable("bac") String bac) {
    logger.info("**********TireFInderRest getYMMTireSizeSummary**********");
    logger.info("**********Tire Size: " + tireSize + "************");
    TireInfoDetails tireInfoDetails = TireInfoDetails.parseTireSize(tireSize);
    return tireInfoService.getTireInfoBySize(year, make, model, tireInfoDetails, bac, null);
}*/

import rest from "../axiosRestCalls";
import store from "../../core/redux/Store";
import {API_BASE_PATH} from "../restConstants";
import {setAxiosCancelSource, setSearchResult, setSpinner} from "../../core/redux/ActionCreator";
import axios from "axios";

const API = API_BASE_PATH;

const SAFE_PARAM_PATTERN = /^[a-zA-Z0-9 _.,'&()-]+$/;
const YEAR_PATTERN = /^\d{4}$/;
const TIRE_SIZE_PATTERN = /^[a-zA-Z0-9_./-]+$/;

function validateParam(value, pattern) {
    if (!value || !pattern.test(value)) {
        throw new Error("Invalid parameter value: " + value);
    }
    return value;
}

class searchResultsService {
    getResults(size, year, make, model, bac) {
        store.dispatch(setSpinner({spinner: true}));
        const source = store.getState().searchResultReducer.axiosCancelSource;
        let parsedSize = size.replace("/", "_");
        let parsedModel = model.replaceAll('/', '_');

        try {
            validateParam(parsedSize, TIRE_SIZE_PATTERN);
            validateParam(year, YEAR_PATTERN);
            validateParam(make, SAFE_PARAM_PATTERN);
            validateParam(parsedModel, SAFE_PARAM_PATTERN);
            validateParam(bac, SAFE_PARAM_PATTERN);
        } catch (e) {
            console.error('Invalid parameter detected:', e.message);
            if (source) {
                source.cancel('Cancelling previous request');
            }
            store.dispatch(setSpinner({spinner: false}));
            return;
        }

        if (source) {
            source.cancel('Cancelling previous request');
        }

        const CancelToken = axios.CancelToken;
        const localSource = CancelToken.source();

        rest.get(API + "tireSize/" + encodeURIComponent(parsedSize) + "/ymm/" + encodeURIComponent(year) + "/" + encodeURIComponent(make)
            + "/" + encodeURIComponent(parsedModel) + "/BAC/" + encodeURIComponent(bac), {cancelToken: localSource.token}).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setSearchResult(res.data));
            }
            store.dispatch(setSpinner({spinner: false}));
        }).catch((e) => {
            if (axios.isCancel(e)) {
                console.log('Request cancelled', e.message);
            }
        });
        store.dispatch(setAxiosCancelSource(localSource));
    }

    getResultsBrand(size, year, make, model, bac, brand) {
        store.dispatch(setSpinner({spinner:true}));
        let parsedSize = size.replace("/", "_");
        let parsedModel = model.replaceAll('/', '_');

        try {
            validateParam(parsedSize, TIRE_SIZE_PATTERN);
            validateParam(year, YEAR_PATTERN);
            validateParam(make, SAFE_PARAM_PATTERN);
            validateParam(parsedModel, SAFE_PARAM_PATTERN);
            validateParam(bac, SAFE_PARAM_PATTERN);
            validateParam(brand, SAFE_PARAM_PATTERN);
        } catch (e) {
            console.error('Invalid parameter detected:', e.message);
            store.dispatch(setSpinner({spinner: false}));
            return;
        }

        rest.get(API + "tireSize/" + encodeURIComponent(parsedSize) + "/ymm/" + encodeURIComponent(year) + "/" + encodeURIComponent(make)
            + "/" + encodeURIComponent(parsedModel) + "/BAC/" + encodeURIComponent(bac) + "/brand/" + encodeURIComponent(brand)).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setSearchResult(res.data));
            }
            store.dispatch(setSpinner({spinner:true}));
        });
    }
}
// eslint-disable-next-line
export default new searchResultsService();
